module.exports = __webpack_public_path__ + "static/img/14010014.b1dd28eb.png";